import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
//import Loading from "../../elements/loading";
import CommissionValidationForm from "../../elements/revision/commission";

class CommissionValidation extends Component {
	render(){
		return (
			<CommissionValidationForm {...this.props}/>
		)
	}

	componentWillMount() {
		this.props.fetchResourseConcepts();
		this.props.fetchCommission();
	}

}

export default BaseLayout(CommissionValidation,{
	title:"Revisión y validación de proyectos",
	subnav:{
		icon: 'fa-check-square-o',
		name: 'Validación de proyectos',
		actions: [
			{
				type: null,
				url: null,
				name: '',
				element: null
			}
		]
	},
	stateNav: false
})


// WEBPACK FOOTER //
// ./src/layouts/revision/commission.jsx